<div class="my-5">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="acs || []"></sm-data-table-builder>
</div>
    